export const getApiBaseUrl = () => {
  const env = import.meta.env as any;
  const VITE_APP_ENV = env?.VITE_APP_ENV;
  const VITE_APP_LOCAL_API_PORT = env?.VITE_APP_LOCAL_API_PORT || "8010";

  if (VITE_APP_ENV === "local") {
    return `http://local.pingintel.com:${VITE_APP_LOCAL_API_PORT}/`;
  }

  const usingSecondary = ["dev2", "staging2", "prod2"].some((subdomain) =>
    window.location.href.includes(`.${subdomain}.`),
  );

  const apiBaseUrls: Record<string, { primary: string; secondary: string }> = {
    prd: {
      primary: "https://app.pingintel.com/",
      secondary: "https://app.prod2.pingintel.com/",
    },
    prdeu: {
      primary: "https://app.eu.pingintel.com/",
      secondary: "https://app.prod2.eu.pingintel.com/",
    },
    stg: {
      primary: "https://app.staging.pingintel.com/",
      secondary: "https://app.staging2.pingintel.com/",
    },
    default: {
      primary: "https://app.dev.pingintel.com/",
      secondary: "https://app.dev2.pingintel.com/",
    },
  };

  const envConfig = VITE_APP_ENV && apiBaseUrls[VITE_APP_ENV] ? apiBaseUrls[VITE_APP_ENV] : apiBaseUrls.default;

  const baseUrl = usingSecondary ? envConfig.secondary : envConfig.primary;

  return baseUrl;
};

// The layers host, which serves both the tile proxy and the API endpoints that go
// with it (layer_cookies). Locally those are two separate servers: only web routes
// layer_cookies, so this returns web and getTileProxyBaseUrl returns pingproxy.
// Cookies ignore ports, so a cookie web mints is still sent to the proxy's port.
export const getTilesApiBaseUrl = () => {
  const env = import.meta.env as any;
  const VITE_APP_ENV = env?.VITE_APP_ENV;

  if (VITE_APP_ENV === "local") {
    return getApiBaseUrl();
  }

  const usingSecondary = ["dev2", "staging2", "prod2", "prodeu2"].some((subdomain) =>
    window.location.href.includes(`.${subdomain}.`),
  );

  const apiBaseUrls: Record<string, { primary: string; secondary: string }> = {
    prd: {
      primary: "https://layers.pingintel.com/",
      secondary: "https://layers.prod2.pingintel.com/",
    },
    prdeu: {
      primary: "https://layers.eu.pingintel.com/",
      secondary: "https://layers.eu2.pingintel.com/",
    },
    stg: {
      primary: "https://layers.staging.pingintel.com/",
      secondary: "https://layers.staging2.pingintel.com/",
    },
    default: {
      primary: "https://layers.dev.pingintel.com/",
      secondary: "https://layers.dev2.pingintel.com/",
    },
  };

  const envConfig = VITE_APP_ENV && apiBaseUrls[VITE_APP_ENV] ? apiBaseUrls[VITE_APP_ENV] : apiBaseUrls.default;

  const baseUrl = usingSecondary ? envConfig.secondary : envConfig.primary;

  return baseUrl;
};

// Where the tiles themselves come from: pingproxy locally, the layers host otherwise.
export const getTileProxyBaseUrl = () => {
  if (import.meta.env.VITE_APP_ENV === "local") {
    const port = import.meta.env.VITE_APP_LOCAL_TILES_PORT || "8013";
    return `http://local.pingintel.com:${port}/`;
  }

  return getTilesApiBaseUrl();
};

export const rebaseLayersToTilesHost = (layers: Record<string, { url?: string }>): Record<string, string> => {
  const tilesBaseUrl = getTileProxyBaseUrl();
  const availableLayers: Record<string, string> = {};

  Object.entries(layers).forEach(([key, value]) => {
    if (value.url) {
      availableLayers[key] = value.url.replace(/^https?:\/\/[^/]+\//i, tilesBaseUrl);
    }
  });

  return availableLayers;
};

export const getVisionApiBaseUrl = () => {
  const env = import.meta.env as any;
  const VITE_APP_ENV = env?.VITE_APP_ENV;
  const VITE_APP_LOCAL_VISION_PORT = env?.VITE_APP_LOCAL_VISION_PORT || "8012";

  if (VITE_APP_ENV === "local") {
    return `http://local.pingintel.com:${VITE_APP_LOCAL_VISION_PORT}/`;
  }

  const usingSecondary = ["dev2", "staging2", "prod2", "prodeu2"].some((subdomain) =>
    window.location.href.includes(`.${subdomain}.`),
  );

  const apiBaseUrls: Record<string, { primary: string; secondary: string }> = {
    prd: {
      primary: "https://vision.pingintel.com/",
      secondary: "https://vision.prod2.pingintel.com/",
    },
    prdeu: {
      primary: "https://vision.eu.pingintel.com/",
      secondary: "https://vision.eu2.pingintel.com/",
    },
    stg: {
      primary: "https://vision.staging.pingintel.com/",
      secondary: "https://vision.staging2.pingintel.com/",
    },
    default: {
      primary: "https://vision.dev.pingintel.com/",
      secondary: "https://vision.dev2.pingintel.com/",
    },
  };

  const envConfig = VITE_APP_ENV && apiBaseUrls[VITE_APP_ENV] ? apiBaseUrls[VITE_APP_ENV] : apiBaseUrls.default;

  const baseUrl = usingSecondary ? envConfig.secondary : envConfig.primary;

  return baseUrl;
};
